import React from "react";
import Link from "next/link";
import Score from "./score";

/**
 *
 */
export type BrandData = {
    id : string
    name : string
    score : number
    proportion : number
};

/**
 *
 */
type Data = {
    brand : BrandData
    embed : boolean
};

/**
 *
 * @param brand
 * @param embed
 * @constructor
 */
export default function Brand ({ brand, embed } : Data) {
    const link = '/brand/' + brand.id;

    // render
    return (
        <div className="product col-12 col-sm-12 col-md-6 col-lg-4 p-1 m-md-0 mb-md-4 mb-3">
            <div className="container p-0 m-0">
                <div className="row">
                    <Link href={link} className="text-decoration-none text-start text-md-center col-2 col-sm-1 col-md-12 mb-md-3">
                        <Score value={brand.score} size={"big"} />
                    </Link>
                    <div className="col-10 col-sm-11 col-md-12 ps-xs-2 ps-sm-5 ps-md-3 pe-md-3">
                        <Link href={link} className={'text-decoration-none'}>
                            {embed ?
                                <h3 className="h5 text-start text-md-center mb-2 text-truncate">{brand.name}</h3>
                                : <h2 className="h5 text-start text-md-center mb-2 text-truncate">{brand.name}</h2>
                            }
                        </Link>
                        <div className="row justify-content-md-center m-0">
                            {/*<Score value={score} size={"small"} />*/}
                            {Object.hasOwn(brand, 'proportion') ? <span className={'fw-bold p-0'}>{brand.proportion}%</span> : ''}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}